<button
	class="clipboard"
	type="button"
	label="Copy to clipboard"
	[tooltip]="outlineView ? null : 'Copied'"
	placement="top"
	triggers=""
	[isOpen]="isCopied$ | async"
	[class.copied]="isCopied$ | async"
	[class.outlineView]="outlineView"
	(click)="copyToClipboard($event)"
>
	<ng-container *ngIf="!(isCopied$ | async)">
		<svg aria-hidden="true" height="16" width="16" data-view-component="true" class="clipboard-icon copy-icon">
			<path
				fill-rule="evenodd"
				d="M5.75 1a.75.75 0 0 0-.75.75v3c0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-.75-.75h-4.5zm.75 3V2.5h3V4h-3zm-2.874-.467a.75.75 0 0 0-.752-1.298A1.75 1.75 0 0 0 2 3.75v9.5c0 .966.784 1.75 1.75 1.75h8.5A1.75 1.75 0 0 0 14 13.25v-9.5a1.75 1.75 0 0 0-.874-1.515.75.75 0 1 0-.752 1.298.25.25 0 0 1 .126.217v9.5a.25.25 0 0 1-.25.25h-8.5a.25.25 0 0 1-.25-.25v-9.5a.25.25 0 0 1 .126-.217z"
			/>
		</svg>
	</ng-container>
	<ng-container *ngIf="isCopied$ | async">
		<svg
			aria-hidden="true"
			height="16"
			width="16"
			data-view-component="true"
			class="clipboard-icon clipboard-icon__check"
		>
			<path
				fill-rule="evenodd"
				d="M13.78 4.22a.75.75 0 0 1 0 1.06l-7.25 7.25a.75.75 0 0 1-1.06 0L2.22 9.28a.75.75 0 0 1 1.06-1.06L6 10.94l6.72-6.72a.75.75 0 0 1 1.06 0z"
			/>
		</svg>
	</ng-container>
</button>
